import { FormattedMessage, useIntl } from 'react-intl'
import { Image, Typography } from 'antd'

import HelpSection from 'src/components/help/HelpSection'
import HelpAccordion from 'src/components/help/HelpAccordion'
import CheckInMethods from 'src/components/help/CheckInMethods'
import EmailList from 'src/components/help/EmailList'
import ReleaseNotice from 'src/components/help/ReleaseNotice'
import HelpContact from 'src/components/help/HelpContact'
import { HelpColumn, PageTitle } from 'src/components/help/styled'

import {
  CHECKIN_METHODS,
  CONTACT_FIELDS,
  DOOR_PHOTO,
  EMAILS,
  RULES,
  TICKET_URL,
  TROUBLE_CAUSES
} from './content'

// Public page, reached from the sheet on the door through mylm.it/aiutosale. The reader is
// standing in a corridor with a meeting starting now, so the problems come before the
// instructions and the rules come last. Reads nothing from redux and calls no API.
const HelpPage = () => {
  const intl = useIntl()

  return (
    <HelpColumn>
      <div>
        <PageTitle level={2}>
          <FormattedMessage id={'help.title'} />
        </PageTitle>
        <Typography.Text type={'secondary'}>
          <FormattedMessage id={'help.subtitle'} />
        </Typography.Text>
      </div>

      <HelpSection titleId={'help.trouble.heading'}>
        <p>
          <FormattedMessage id={'help.trouble.hint'} />
        </p>
        <HelpAccordion
          prefix={'help.trouble'}
          items={TROUBLE_CAUSES}
          titleKey={'title'}
        />
      </HelpSection>

      <HelpSection titleId={'help.howto.heading'}>
        <CheckInMethods methods={CHECKIN_METHODS} />
        {DOOR_PHOTO ? (
          <Image
            src={DOOR_PHOTO}
            alt={intl.formatMessage({ id: 'help.howto.photoAlt' })}
          />
        ) : null}
      </HelpSection>

      <HelpSection titleId={'help.rules.heading'}>
        <HelpAccordion prefix={'help.rules'} items={RULES} titleKey={'q'} />
      </HelpSection>

      <HelpSection titleId={'help.emails.heading'}>
        <EmailList emails={EMAILS} />
      </HelpSection>

      <ReleaseNotice />

      <HelpSection titleId={'help.contact.heading'}>
        <HelpContact fields={CONTACT_FIELDS} ticketUrl={TICKET_URL} />
      </HelpSection>
    </HelpColumn>
  )
}
export default HelpPage
